import { Box, TextField, TextFieldProps } from "@mui/material";
import { useField } from "formik";
import React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

import FieldErrorFeedbackFormatter from "components/forms/FieldErrorFeedbackFormatter";
import { MakeRequired } from "utils/types";

import FormikLabel from "../FormikLabel";

type Props = Omit<
  NumericFormatProps<MakeRequired<TextFieldProps, "name">>,
  "onChange"
> & {
  onChange?: (value: number | undefined) => void;
};

const FormikNumberField = ({
  name,
  label,
  helperText,
  onChange,
  ...rest
}: Props) => {
  const [field, meta, helper] = useField<number>(name);

  let helperTextValue;
  if (helperText !== false) {
    helperTextValue =
      meta.touched && meta.error ? (
        <FieldErrorFeedbackFormatter error={meta.error} />
      ) : (
        helperText
      );
  }

  return (
    <Box>
      <FormikLabel>{label}</FormikLabel>
      <NumericFormat
        fullWidth
        error={meta.touched && !!meta.error}
        helperText={helperTextValue}
        thousandSeparator
        {...field}
        {...rest}
        onChange={() => {}}
        isAllowed={(values) => {
          const { floatValue } = values;
          if (floatValue) {
            if (rest.min && floatValue < rest.min) return false;
            if (rest.max && floatValue > rest.max) return false;
          }

          return true;
        }}
        onValueChange={(values) => {
          const { floatValue } = values;

          if (onChange) {
            onChange(floatValue);
          }

          helper.setValue(floatValue as number);
        }}
        customInput={TextField}
      />
    </Box>
  );
};

export default FormikNumberField;
